import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyA-7psntxswMlb0yrqjSk9v3RX11631qac",
  authDomain: "ninja-blog-80fc3.firebaseapp.com",
  projectId: "ninja-blog-80fc3",
  storageBucket: "ninja-blog-80fc3.appspot.com",
  messagingSenderId: "813867934098",
  appId: "1:813867934098:web:317cfcc687ea769b5a214b"
};

// init firebase
firebase.initializeApp(firebaseConfig);

// init firestore service
const projectFirestore = firebase.firestore();
// init firestore authentication service
const projectAuth = firebase.auth();
// // init firestore storage service
const projectStorage = firebase.storage();

// 將timestamp 這個function(可以自動產生當下的timestamp) 取出
const timestamp = firebase.firestore.FieldValue.serverTimestamp;
// 日後component要使用時，import進去以供使用
export { projectFirestore, projectAuth, projectStorage, timestamp};

